// extracted by mini-css-extract-plugin
export var onHomePage = "QuickLinks-module--onHomePage--2af6a";
export var quicklinkswrapper = "QuickLinks-module--quicklinkswrapper--2ef89";
export var swiper = "QuickLinks-module--swiper--f1fd8";
export var swiperwrapper = "QuickLinks-module--swiperwrapper--6967e";